import { Alert } from "antd";

const AlertMessage = ({ message, type }) => {
    return (
        <div className='alert'>
            <Alert message={message} type={type} showIcon />
        </div>
    );
};

export default AlertMessage;
